import { useMutation } from '@tanstack/react-query';

import { PluginBankStatementsBrokerRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runBankStatementsBrokerRequest } from '../../requests/runBankStatementsBrokerRequest';

export const useRunBankStatementsBrokerRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: ({
      data,
      documentParams,
    }: {
      data: PluginBankStatementsBrokerRequest;
      documentParams: DocumentParams;
    }) => runBankStatementsBrokerRequest(constructPost, data, documentParams),
    onSuccess: () => handleSuccess('Bank statements request submitted'),
    onError: () => handleError('Bank statements request failed'),
  });
  return { runBankStatementsBrokerRequest: mutateAsync, ...rest };
};
